export default "__VITE_ASSET__C8p7W3X0__"